import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Popconfirm, Tooltip, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toggleReportReview } from '../../actions';
import { colors, rightSideBarColor } from '../../lib/theme';

class Report extends Component {

    toggleReport = () => {
        const { review, userDetails } = this.props;
        const reportedArray = review.reportedArray || [];
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to report the review.');
            return;
        }
        const alreadyReported = userDetails.uid && (reportedArray.includes(userDetails.uid));
        console.dir(review);
        if (alreadyReported) {
            this.props.toggleReportReview(userDetails.uid, review.id, 'unreport');
        } else {
            this.props.toggleReportReview(userDetails.uid, review.id, 'report');
        }
    }

    render() {
        const { review, userDetails } = this.props;
        const reportedArray = review.reportedArray || [];
        const alreadyReported = userDetails && userDetails.uid && (reportedArray.includes(userDetails.uid));

        return (
            <div>
                <Tooltip title={alreadyReported ? 'Unreport' : 'Report'}>
                    <Popconfirm title={alreadyReported ? 'Are you sure you want to unreport this?' : 'Are you sure you want to report this as inappropriate?'} onConfirm={this.toggleReport}>
                        {/* <a onClick={this.toggleReport}> */}
                        <a>
                            {!alreadyReported && reportedArray.length > 0 && <span style={{ color: `${colors.danger}` }}>
                                <FontAwesomeIcon icon='flag' /> {reportedArray.length}
                            </span>}
                            {!alreadyReported && reportedArray.length < 1 && <span style={{ color: 'lightgray' }}>
                                <FontAwesomeIcon icon='flag' />
                            </span>}
                            {alreadyReported && <span style={{ color: `${colors.danger}` }}>
                                <FontAwesomeIcon icon='flag' />&nbsp;
                                {reportedArray.length == 1 && `You reported this`}
                                {reportedArray.length == 2 && `You and 1 other reported this`}
                                {reportedArray.length > 2 && `You and ${reportedArray.length - 1} others reported this`}
                            </span>}
                        </a>
                    </Popconfirm>
                </Tooltip>
            </div>
        )
    }
}

Report.propTypes = {
    userDetails: PropTypes.object,
    review: PropTypes.object.isRequired,
    toggleReportReview: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleReportReview: bindActionCreators(toggleReportReview, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Report)